import {
  _sharedActionsConstantsFeaturedSearch,
  _sharedActionsFeaturedSearch
} from "@/shared/store/featuredSearch/actions";

export const actionsConstantsFeaturedSearch = _sharedActionsConstantsFeaturedSearch;
export const actionsFeaturedSearch = _sharedActionsFeaturedSearch;
